import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import OrbElement from './orb-element/OrbElement';
import './IndicationOrbs.scss';

const IndicationOrbs = ({ list, current }) => {
  const [orbsConfig, setOrbsConfig] = useState([]);

  useEffect(() => {
    const currentIndex = list.indexOf(current);
    const orbsConfig = list.map((listEl, i) => ({
      id: listEl,
      position: i < currentIndex ? 'prev' : i > currentIndex ? 'next' : 'curr',
    }));
    setOrbsConfig(orbsConfig);
  }, [current, list]);

  return <div className="indication-orbs">{orbsConfig.map(OrbElement)}</div>;
};

IndicationOrbs.propTypes = {
  list: PropTypes.arrayOf(PropTypes.string).isRequired,
  current: PropTypes.string.isRequired,
};

export default IndicationOrbs;
